// src/LabourLawAgent/LabourLawAgent.js
import React, { useState } from "react";
import { Box, Tabs, Tab, Badge } from "@mui/material";

// Import pane modules
import * as SearchPaneMod from "./panes/SearchPane";
import * as AboutPaneMod from "./panes/AboutPane";
import * as DocumentManagementPaneMod from "./panes/DocumentManagementPane";
import * as TemplatesFormatPaneMod from "./panes/TemplatesFormatPane";
import * as ComplianceCalendarPaneMod from "./panes/ComplianceCalendarPane";
import * as BlogsPaneMod from "./panes/BlogsPane";
import * as UserManagementPaneMod from "./panes/UserManagementPane";
import * as StatisticsPaneMod from "./panes/StatisticsPane";
// 🔻 RecentUpdatesPane removed
import * as NotificationsPaneMod from "./panes/NotificationsPane";
import * as ChatbotMod from "./panes/Chatbot"

function resolvePane(mod, named) {
  if (!mod) return null;
  const maybeDefault = mod.default;
  const maybeNamed = mod[named];
  if (typeof maybeDefault === "function") return maybeDefault;
  if (typeof maybeNamed === "function") return maybeNamed;
  return null;
}

const SearchPane = resolvePane(SearchPaneMod, "SearchPane");
const AboutPane = resolvePane(AboutPaneMod, "AboutPane");
const DocumentManagementPane = resolvePane(
  DocumentManagementPaneMod,
  "DocumentManagementPane"
);
const TemplatesFormatPane = resolvePane(
  TemplatesFormatPaneMod,
  "TemplatesFormatPane"
);
const ComplianceCalendarPane = resolvePane(
  ComplianceCalendarPaneMod,
  "ComplianceCalendarPane"
);
const BlogsPane = resolvePane(BlogsPaneMod, "BlogsPane");
const UserManagementPane = resolvePane(
  UserManagementPaneMod,
  "UserManagementPane"
);
const StatisticsPane = resolvePane(StatisticsPaneMod, "StatisticsPane");
// 🔻 RecentUpdatesPane removed
const NotificationsPane = resolvePane(
  NotificationsPaneMod,
  "NotificationsPane"
);
const Chatbot = resolvePane(ChatbotMod, "Chatbot");

const LabourLawAgent = ({ orgId, userId }) => {
  const [tab, setTab] = useState(0);
  const [notifUnread, setNotifUnread] = useState(0);

  // Summary forwarded to BlogsPane
  const [incomingSummary, setIncomingSummary] = useState(null);

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <Tabs
        value={tab}
        onChange={(e, v) => setTab(v)}
        sx={{ px: 2, pt: 1, flexWrap: "wrap" }}
      >
        <Tab label="Search" /> {/* index 0 */}
        <Tab label="About App" /> {/* index 1 */}
        <Tab label="Document Management" /> {/* index 2 */}
        <Tab label="Templates Format" /> {/* index 3 */}
        <Tab label="Compliance Calendar" /> {/* index 4 */}
        <Tab label="From the Host" /> {/* index 5 */}
        <Tab label="User Management" /> {/* index 6 */}
        <Tab label="Statistics" /> {/* index 7 */}
        <Tab label="Lawbot" /> {/* index 8 */}
        {/* Notifications is now index 9 */}
        <Tab
          label={
            <Badge
              color="error"
              invisible={notifUnread === 0}
              badgeContent={notifUnread > 99 ? "99+" : notifUnread}
            >
              Notifications
            </Badge>
          }
        />
      </Tabs>


      <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        {tab === 0 && SearchPane && <SearchPane orgId={orgId} />}
        {tab === 1 && AboutPane && <AboutPane />}

        {tab === 2 && DocumentManagementPane && (
          <DocumentManagementPane
            onGotoAISummary={(payload) => {
              setIncomingSummary(payload);
              setTab(5); // Go to "From the Host"
            }}
          />
        )}

        {tab === 3 && TemplatesFormatPane && (
          <TemplatesFormatPane orgId={orgId} />
        )}
        {tab === 4 && ComplianceCalendarPane && (
          <ComplianceCalendarPane orgId={orgId} />
        )}

        {tab === 5 && BlogsPane && (
          <BlogsPane orgId={orgId} newSummary={incomingSummary} />
        )}

        {tab === 6 && UserManagementPane && (
          <UserManagementPane orgId={orgId} />
        )}
        {tab === 7 && StatisticsPane && (
          <StatisticsPane orgId={orgId} />
        )}
        {tab === 8 && Chatbot && <Chatbot orgId={orgId} />}
        {/* 🔻 RecentUpdatesPane removed, Notifications shifted from 9 -> 8 */}
        {tab === 9 && NotificationsPane && (
          <NotificationsPane
            orgId={orgId}
            userId={userId}
            onUnreadChange={setNotifUnread}
          />
        )}
        
      </Box>
    </Box>
  );
};

export default LabourLawAgent;
